import { NgModule } from '@angular/core';
import {MenubarModule} from 'primeng/menubar';
import {TabMenuModule} from 'primeng/tabmenu';
import {CardModule} from 'primeng/card';
import {ButtonModule} from 'primeng/button';
import {PanelModule } from 'primeng/panel';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { PanelMenuModule } from 'primeng/panelmenu';
import { InputTextModule } from 'primeng/inputtext';
import { DataViewModule } from 'primeng/dataview';
import { TabViewModule } from 'primeng/tabview';
import {SpinnerModule} from 'primeng/spinner';
import {AccordionModule} from 'primeng/accordion';
import {DropdownModule} from 'primeng/dropdown';
import {SelectItem} from 'primeng/api'; 
import {InputMaskModule} from 'primeng/inputmask';
import {CheckboxModule} from 'primeng/checkbox';
import {CalendarModule} from 'primeng/calendar';
import {TooltipModule} from 'primeng/tooltip';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FieldsetModule} from 'primeng/fieldset';
import { SidebarModule } from 'primeng/sidebar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {ToolbarModule} from 'primeng/toolbar';
import {NgxPrintModule} from '../modules/ngx-print.module';
import {FileUploadModule} from 'primeng/fileupload';
import {ListboxModule} from 'primeng/listbox';
import {EditorModule} from 'primeng/editor';
import {MultiSelectModule} from 'primeng/multiselect';
import {InputSwitchModule} from 'primeng/inputswitch';
import { KeyFilterModule } from 'primeng/keyfilter';
// import {InputNumberModule} from 'primeng/inputnumber';
@NgModule({
  imports: [
    MenubarModule,
    CardModule,
    ButtonModule,
    DynamicDialogModule,
    DialogModule,
    TabMenuModule,
    PanelModule,
    ScrollPanelModule,
    TableModule,
    VirtualScrollerModule,
    PanelMenuModule,
    InputTextModule,
    DataViewModule,
    TabViewModule,
    SpinnerModule,
    AccordionModule,
    DropdownModule,  
    InputMaskModule,
    DropdownModule,
    CheckboxModule,
    TooltipModule,
    CalendarModule,
    RadioButtonModule,
    FieldsetModule,
    SidebarModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    ToolbarModule,
    NgxPrintModule,
    FileUploadModule,
    ListboxModule,
    EditorModule,
    MultiSelectModule,
    InputSwitchModule,
    KeyFilterModule
    // InputNumberModule
  ],
  exports: [
    MenubarModule,
    CardModule,
    ButtonModule,
    DynamicDialogModule,
    DialogModule,
    TabMenuModule,
    PanelModule,
    ScrollPanelModule,
    TableModule,
    VirtualScrollerModule,
    PanelMenuModule,
    InputTextModule,
    DataViewModule,
    TabViewModule,
    SpinnerModule,
    AccordionModule,
    DropdownModule,    
    InputMaskModule,
    DropdownModule,
    CheckboxModule,
    TooltipModule,
    CalendarModule,
    RadioButtonModule,
    FieldsetModule,
    SidebarModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    ToolbarModule,
    NgxPrintModule,
    FileUploadModule,
    ListboxModule,
    EditorModule,
    MultiSelectModule,
    InputSwitchModule,
    KeyFilterModule
    // InputNumberModule
  ],
  providers: [
    ConfirmationService,
  ],
})
export class PrimeNgModule { }
